export const VERSION_NUMBER = '1.100';
export const BUILD_TIME = '';
export const BUILD_NOTES =
    '<ul><li>Fixed issue with confirmed cases and quarantine charts not properly defaulting to most recent 14 days correctly.</li></ul>';
